import RangeDateJs from '@components/rangeDateTimeJs';
import { EModePanelSelect, SelectPanel } from '@components/SelectPanelReport/SelectPanel';
import { IReflect } from '@models/Log';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { updatePageLoadingApi, updateSelectDateTime } from '@slice/select.slice';
import { Button, message, Tag } from 'antd';
import Tooltip from 'react-tooltip-lite';
import AdminLogApi from 'apis/api/AdminLog';
import { RootState } from 'app/store';
import Helpers from 'helpers/Helpers';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Table, { IColumnTable } from '@components/table-devextreme/Table';
import ViewButton from '@components/table-devextreme/buttons/ViewButton';
import ModalDetailReflect from './ModalDetailReflect';
import { FaPaperclip } from 'react-icons/fa';
import Layout from '@components/Layout';
import envStore, { publicUrl } from '@utils/env';
import ModalViewIpInfo from './ModalViewIpInfo';
import { COLORS, DELAY_HTOOLTIP } from 'global/Global';
import moment from 'moment';
import ExportExcelButton from './Excel/ExportExcel';

function Reflect() {
  const { t } = useTranslation();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const timeSelected = useSelector((state: RootState) => state.select.selectedTime);
  const [inputValue, setInputValue] = useState<any>('');
  const [data, setData] = useState<Array<IReflect>>([]);
  const [isShowView, setIsShowView] = useState<boolean>(false);
  const [isShowViewIpInfo, setIsShowViewIpInfo] = useState<boolean>(false);

  const [rowModify, setRowModify] = useState<IReflect>();

  // Hàm tạo Tag màu cho priority
  const getPriorityTag = (priorityValue: string) => {
    const colorMap: Record<string, string> = {
      '0': 'default', // Chỉ để tham khảo
      '1': 'default', // Chỉ để tham khảo
      '2': 'blue', // Xem xét trong thời gian tới
      '3': 'purple', // Mức trung bình, nên xử lý sớm
      '4': 'orange', // Nghiêm trọng, cần xử lý gấp
      '5': 'red' // Rất nghiêm trọng, xử lý khẩn cấp
    };

    const found = options2.find(opt => opt.value === priorityValue);
    return found ? (
      <Tag color={colorMap[priorityValue] || 'default'}>
        <span>{found.label || 'Không xác định'}</span>
      </Tag>
    ) : (
      <Tag color={'default'}>
        <span>{'Không xác định'}</span>
      </Tag>
    );
  };

  const options: any[] = [
    { label: 'Báo cáo sự việc/sự cố', value: '1' },
    { label: 'Góp ý cải thiện quy trình/chính sách', value: '2' },
    { label: 'Ý tưởng sáng tạo', value: '3' },
    { label: 'Vấn đề về môi trường làm việc', value: '4' },
    { label: 'Khác (ghi rõ trong nội dung)', value: '5' }
  ];

  const options2: any[] = [
    { label: '1 – Chỉ để tham khảo', value: '1' },
    { label: '2 – Xem xét trong thời gian tới', value: '2' },
    { label: '3 – Mức trung bình, nên xử lý sớm', value: '3' },
    { label: '4 – Nghiêm trọng, cần xử lý gấp', value: '4' },
    { label: '5 – Rất nghiêm trọng, xử lý khẩn cấp', value: '5' }
  ];

  const options3: any[] = [
    // { label: 'Phòng PNC', value: 'PNC', color: COLORS[1] },
    // { label: 'Phòng CSKH', value: 'CSKH', color: COLORS[25] },
    // { label: 'Phòng Kinh doanh', value: 'KD', color: COLORS[2] },
    // { label: 'Phòng Kỹ thuật', value: 'KTH', color: COLORS[5] },
    // { label: 'Phòng Sản xuất', value: 'SX', color: COLORS[23] },
    // { label: 'Phòng Kế toán', value: 'KTO', color: COLORS[35] }
    { label: 'Phòng Nghiên cứu', value: 'PNC' },
    { label: 'Phòng Chăm sóc khách  hàng', value: 'CSKH' },
    { label: 'Phòng Kinh doanh', value: 'KD' },
    { label: 'Phòng Kỹ thuật', value: 'KTH' },
    { label: 'Phòng Sản xuất', value: 'SX' },
    { label: 'Phòng Kế toán', value: 'KTO' },
    { label: 'Chi nhánh Hà Nội', value: 'CNHN' },
    { label: 'Chi nhánh Đà Nẵng', value: 'CNDN' },
    { label: 'Chi nhánh Cần Thơ', value: 'CNCT' },
    { label: 'Không xác định', value: 'OTHER' }
  ];

  const onSelectDateSearch = useCallback(
    (value: any, stringValue?: string[], isTrueFormat?: boolean) => {
      if (stringValue) {
        const timeFormat = isTrueFormat ? value : Helpers.FormatTimeToISOStringSave(value);

        dispatch(
          updateSelectDateTime({
            beginTime: timeFormat[0],
            endTime: timeFormat[1]
          })
        );
      }
    },
    [timeSelected]
  );

  const callApi = async bodyReq => {
    await AdminLogApi.GetListReflect(bodyReq.begin, bodyReq.end).then(res => {
      if (!res.data.error) {
        if (res.data.data.length > 0) {
          setData(res.data.data);
          message.success(t('Administrator.Reflect.GetValueSucces'));
        } else {
          setData(res.data.data);
          message.error(t('Administrator.Reflect.GetValueFailure'));
        }
        // form && form.setFieldsValue(initialsValue);
        // props.callBackRefresh();
        // props.callBackCloseModal();
      } else {
        if (res.data.messageCode == 'CODE_EXIST') message.error(t('System.ExistData'));
        else message.error(t('Administrator.Reflect.GetValueFailure'));
      }
      //   setConfirmLoading(false);
    });
  };

  const handleGetValue = async () => {
    const bodyReq = {
      begin: timeSelected.beginTime.slice(0, 19),
      end: timeSelected.endTime.slice(0, 19)
    };
    dispatch(updatePageLoadingApi(true));
    try {
      if (bodyReq) {
        // console.log('dataBody', bodyReq);
        // setConfirmLoading(true);
        callApi(bodyReq);
      }
      dispatch(updatePageLoadingApi(false));
    } catch (error) {
      console.log(error);
      //   setConfirmLoading(false);
      message.error(t('Administrator.Reflect.GetValueFailure'));
    }
  };

  //   useEffect(() => {
  //     handleGetValue();
  //   }, []);

  const getValue = useMemo(() => {
    return (
      <div className="flex z-10 flex-wrap ">
        <div className="flex">
          <div className="pr-2">
            <RangeDateJs
              limitTimeRange={31}
              onSelectDateChange={(date, stringDate) => onSelectDateSearch(date, stringDate)}
            />
          </div>
          <div className=" lg:pl-1 pr-2">
            {/* <Button type={'primary'} ghost onClick={() => handleView()}> */}
            <Button type={'primary'} onClick={handleGetValue}>
              {t('Button.View')}
            </Button>
          </div>
          {data.length > 0 && (
            <div className=" lg:pl-1">
              {/* <Button type={'primary'} ghost onClick={() => handleView()}> */}
              <ExportExcelButton />
            </div>
          )}
        </div>
      </div>
    );
  }, [timeSelected, data]);

  const ClickBtnView = (valueRow: IReflect) => {
    if (valueRow) {
      setRowModify(valueRow);
      setIsShowView(true);
      // clickOpenModal(true);
    }
  };

  const ClickBtnViewIpInfo = (valueRow: IReflect) => {
    if (valueRow) {
      setRowModify(valueRow);
      setIsShowViewIpInfo(true);
      // clickOpenModal(true);
    }
  };

  const mapCodesToLabels = (codes: any, options: any[]) => {
    return (
      codes
        ?.split(';')
        .map(v => v.trim())
        .map(code => options.find(opt => opt.value === code)?.label)
        .filter(Boolean)
        .join(', ') || 'Không xác định'
    );
  };

  // Hàm map nhiều code sang label
  const mapCodesToTags = (codes: string, opts: any[]) => {
    if (!codes) return <Tag color="default">Không xác định</Tag>;
    return codes
      .split(';')
      .map(v => v.trim())
      .map(code => {
        const found = opts.find(opt => opt.value === code);
        return found ? (
          <Tag className="my-1" key={code}>
            {found.label}
          </Tag>
        ) : null;
      });
  };

  const dataTable = useMemo(() => {
    return data
      .sort((a: any, b: any) => {
        return new Date(b.createTime).valueOf() - new Date(a.createTime).valueOf();
      })
      .map((item: IReflect, index: number) => {
        const typet = mapCodesToLabels(item.type, options);
        const priorityt = mapCodesToLabels(item.priority, options2);
        const dept = mapCodesToLabels(item.department, options3);
        return {
          ...item,
          STTEXport: index + 1,
          departmentValue: item.department,
          departmentLabel: dept,
          typeValue: item.type,
          typeLabel: typet,
          priorityValue: item.priority,
          priorityLabel: priorityt,
          ip: item.ip.startsWith(':') ? '' : item.ip
        };
      });
  }, [data]);

  const columns: IColumnTable[] = useMemo(() => {
    return [
      {
        type: 'buttons',
        dataField: 'Function',
        alignment: 'center',
        // minWidth: 40,
        width: 60,
        caption: '',
        allowHiding: false,
        showInColumnChooser: false,
        allowFiltering: false,
        allowSorting: false,
        cellRender: (props: any) => {
          return (
            <div className="flex space-x-2 items-center ">
              <ViewButton title={'Thông tin chi tiết'} onClick={() => ClickBtnView(props.data)} />
              <Tooltip
                direction="down"
                eventOff="onClick"
                content={t('Table.Tooltip.ShowIp')}
                hoverDelay={DELAY_HTOOLTIP}
                // className={props.hidden ? 'invisible' : ''}
              >
                <div className={`${props.data.ip ? '' : 'hidden'} cursor-pointer`}>
                  <img
                    color="#0155cc"
                    width={18}
                    height={18}
                    src={`${publicUrl}/img/login/ip-address.png`}
                    alt="Lỗi"
                    onClick={() => ClickBtnViewIpInfo(props.data)}
                  />
                </div>
              </Tooltip>
            </div>
          );
        },
        fixed: true
      },
      //   {
      //     dataField: 'id',
      //     caption: 'Administrator.Reflect.UniqueId',
      //     // minWidth: 70
      //     width: 70
      //   },
      {
        dataField: 'STTEXport',
        alignment: 'right', // center | right | left
        caption: 'Table.STT',
        minWidth: 40,
        width: 60,
        allowFiltering: false,
        allowSorting: false
      },
      {
        dataField: 'fileUrl',
        caption: 'Administrator.Reflect.FileUrl',
        // minWidth: 250,
        width: 100,
        // lookupFilter: true,
        // lookupAt: 'isLockedText',
        cellRender: (props: any) => {
          const handleDownload = async () => {
            try {
              const fixedUrl = props.data.fileUrl.replace(/\\/g, '/');
              const fullUrl = `${envStore.apiBaseUrl}${fixedUrl}`;

              // envStore.apiBaseUrl}/${props.data.Picture
              const res = await fetch(fullUrl, { method: 'GET' });
              if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

              const blob = await res.blob();

              // Lấy tên file từ URL
              const fileName = fixedUrl.split('/').pop() || 'downloaded_file.zip';

              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = fileName;
              document.body.appendChild(a);
              a.click();

              a.remove();
              window.URL.revokeObjectURL(url);
            } catch (err) {
              console.error('Lỗi tải file:', err);
            }
          };

          return props.data.fileUrl ? (
            <button onClick={handleDownload} className="text-blue-500 hover:underline flex items-center justify-center">
              <FaPaperclip className="mr-1" /> Tải xuống
            </button>
          ) : (
            '-'
          );
        }
      },
      {
        dataField: 'title',
        caption: 'Administrator.Reflect.Title',
        minWidth: 250
        // width: 120
      },
      {
        dataField: 'departmentLabel',
        caption: 'Administrator.Reflect.Department',
        // minWidth: 50,
        width: 150,
        lookupFilter: true,
        lookupAt: 'departmentLabel'
        // cellRender: (props: any) => {
        //   return (
        //     <div
        //       style={{
        //         backgroundColor: `${
        //           options3.find(opt => opt.label === props.row.data.departmentLabel)?.color || 'black'
        //         }`,
        //         color: 'white'
        //       }}
        //       className={'rounded px-1 w-fit !text-sm select-none'}
        //     >
        //       {props.row.data.departmentLabel}
        //     </div>
        //   );
        // }
      },
      {
        dataField: 'typeLabel',
        caption: 'Administrator.Reflect.Type',
        // minWidth: 50,
        width: 300,
        cellRender: (props: any) => {
          return <>{mapCodesToTags(props.row.data.type, options)}</>;
        }
      },
      {
        dataField: 'priorityLabel', // tên phân quyền gốc
        caption: 'Administrator.Reflect.Priority',
        width: 230,
        lookupFilter: true,
        lookupAt: 'priorityLabel',
        cellRender: props => {
          return getPriorityTag(props.data.priority);
        }
        // lookupFilter: true,
        // lookupAt: 'api'
      },
      //   {
      //     dataField: 'confirm', // tên phân quyền chi tiết
      //     caption: 'Administrator.Reflect.Confirm',

      //     alignment: 'center',
      //     width: 80
      //   },

      {
        dataField: 'ip',
        caption: 'Administrator.Reflect.Ip',
        width: 150
        // minWidth: 50
      },
      //   {
      //     dataField: 'ipInfo',
      //     caption: 'Administrator.Reflect.IpInfo',
      //     width: 150
      //     // minWidth: 50
      //   },
      {
        dataField: 'createTime',
        caption: 'Administrator.Reflect.CreateTime',
        minWidth: 150,
        // minWidth: 150,
        dataType: 'datetime',
        format: 'HH:mm:ss dd/MM/yyyy'
      }
    ];
  }, []);

  const renderTable = useMemo(() => {
    return (
      <Table
        tableName={t('Menu.Administrator.ViewLog')}
        tableId="thongkephananh"
        keyExpr="id"
        columns={columns}
        data={dataTable}
        fileNameExport={t('Menu.Administrator.ViewLog')}
        // onClickAddRecord={() => setIsOpenCreate(true)}
        hiddenAddButton={true}
        isHiddenToolbar={false}
        wrapTextData={true}
        reload={true}
        allowExcel={false}
        oncClickReload={() => {
          handleGetValue();
        }}
        // customCenterToolbar={() => <TableTitle title={t('Menu.Administrator.ViewLog')} />}
      />
    );
  }, [dataTable, columns]);

  return (
    <Layout path={[{ name: 'Quản Lý Phản Hồi' }]}>
      {isShowView && (
        <ModalDetailReflect
          isOpen={isShowView}
          rowSelect={rowModify}
          callBackClose={() => setIsShowView(false)}
          //   callBackRefresh={callBackRefresh}
          // callBackUpdate={callBackUpdate}
          // dataAccountant={dataAccountant}
        />
      )}
      {isShowViewIpInfo && (
        <ModalViewIpInfo
          isOpen={isShowViewIpInfo}
          rowSelect={rowModify}
          callBackClose={() => setIsShowViewIpInfo(false)}
          //   callBackRefresh={callBackRefresh}
          // callBackUpdate={callBackUpdate}
          // dataAccountant={dataAccountant}
        />
      )}
      <div className="relative max-h-[80vh] ">
        <div className="absolute z-10">{getValue}</div>
        <div className="mb-4 lg:mb-0 ">{renderTable}</div>
      </div>
    </Layout>
  );
}

export default Reflect;
